var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "request-info" },
    [
      _vm.showShipments && _vm.isMCFOrder
        ? _c(
            "div",
            [
              _c("h4", { staticClass: "expanded-title" }, [
                _vm._v("\n      Shipment/Fulfilment Details\n    "),
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.shipments },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "Item Description",
                      prop: "item_description",
                      width: "200",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Quantity",
                      prop: "quantity",
                      width: "200",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Ship Date", prop: "shipping_datetime" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("time-zone-formatter", {
                                attrs: {
                                  "current-time": scope.row.shipping_datetime,
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1555129055
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Estimated Arrival",
                      prop: "arrival_datetime",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("time-zone-formatter", {
                                attrs: {
                                  "current-time": scope.row.arrival_datetime,
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2168590622
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Tracking Number", prop: "tracking_id" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Shipment Status",
                      prop: "shipment_status",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h4", { staticClass: "expanded-title" }, [
        _vm._v("\n    Request Details\n    "),
        _c(
          "a",
          {
            staticStyle: { float: "right" },
            on: {
              click: function ($event) {
                return _vm.copyData()
              },
            },
          },
          [_vm._v("Copy Request\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("customer-request-copy-data", {
        ref: "copyRequestModal",
        attrs: { request: _vm.request },
      }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 40 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("h4", [_vm._v("Reasons/Parts")]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.request.reasons },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "Code", prop: "code", width: "100" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Reason", prop: "reason" },
                  }),
                  _vm._v(" "),
                  _vm.request.type !== "part"
                    ? _c("el-table-column", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm.request.has_return_label
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "warning",
                                            size: "mini",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Return label\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3481044069
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.request.type === "part"
                    ? _c("el-table-column", {
                        attrs: {
                          width: "100",
                          label: "Quantity",
                          prop: "quantity",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.request.type === "part"
                    ? _c("el-table-column", {
                        attrs: { width: "150", label: "SKU", prop: "sku" },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("h4", [_vm._v("Customer Address")]),
            _vm._v(" "),
            _c("div", { staticClass: "request-address-row" }, [
              _c("b", [_vm._v("Address:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.address.address_1))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "request-address-row" }, [
              _c("b", [_vm._v("Address 2:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.address.address_2))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "request-address-row" }, [
              _c("b", [_vm._v("City:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm._f("capitalize")(_vm.address.city))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "request-address-row" }, [
              _c("b", [_vm._v("State:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm._f("uppercase")(_vm.address.state))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "request-address-row" }, [
              _c("b", [_vm._v("Zip:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm._f("capitalize")(_vm.address.zip))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "request-address-row" }, [
              _c("b", [_vm._v("Country:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm._f("capitalize")(_vm.address.country))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "request-address-row" }, [
              _c("b", [_vm._v("Phone:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.address.phone))]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("h4", [_vm._v("Shipping")]),
            _vm._v(" "),
            _c("div", { staticClass: "request-address-row" }, [
              _c("b", [_vm._v("Market:")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm._f("capitalize")(_vm.address.market))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "request-address-row" }, [
              _c("b", [_vm._v("GID:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.request.gid || "N/A"))]),
            ]),
            _vm._v(" "),
            _vm.request.owned_sku
              ? _c("div", { staticClass: "request-address-row" }, [
                  _c("b", [_vm._v("Original SKU:")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("uppercase")(_vm.request.owned_sku))),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.request.type === "replacement" && _vm.request.sku
              ? _c("div", { staticClass: "request-address-row" }, [
                  _c("b", [_vm._v("Shipped SKU:")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("uppercase")(_vm.request.sku))),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.request.type === "replacement"
              ? _c("div", { staticClass: "request-address-row" }, [
                  _c("b", [_vm._v("Replacement ID:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.request.new_device_id))]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.request.type === "replacement"
              ? _c("div", { staticClass: "request-address-row" }, [
                  _c("b", [_vm._v("Stock:")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("uppercase")(_vm.request.stock))),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.request.kustomer_url
              ? _c(
                  "div",
                  { staticClass: "request-address-row" },
                  [
                    _c("b", [_vm._v("Kustomer URL:")]),
                    _vm._v(" "),
                    _vm.isKustomerURL(_vm.request.kustomer_url)
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.request.kustomer_url,
                              target: "_blank",
                            },
                          },
                          [_vm._v("Kustomer Link")]
                        )
                      : _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content:
                                "The url entered in the order is invalid",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "word-break": "break-all",
                                  "padding-left": "8px",
                                },
                              },
                              [_vm._v(_vm._s(_vm.request.kustomer_url))]
                            ),
                          ]
                        ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.enableReturnLabels
        ? _c(
            "div",
            [
              _c(
                "h4",
                { staticClass: "expanded-title flex" },
                [
                  _vm._v("\n      Return Labels\n      "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.generateLabelTooltip,
                        disabled: _vm.canGenerateLabel,
                        placement: "top",
                      },
                    },
                    [
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "left",
                            width: "300",
                            disabled: !_vm.canGenerateLabel,
                          },
                          model: {
                            value: _vm.visible,
                            callback: function ($$v) {
                              _vm.visible = $$v
                            },
                            expression: "visible",
                          },
                        },
                        [
                          _c("h5", [_vm._v("Custom Email form")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { margin: "10px 0px" } },
                            [
                              _c("el-input", {
                                attrs: { size: "small", placeholder: "Email" },
                                model: {
                                  value: _vm.customEmail,
                                  callback: function ($$v) {
                                    _vm.customEmail = $$v
                                  },
                                  expression: "customEmail",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#999",
                                    "text-align": "center",
                                    "font-size": "12px",
                                    margin: "10px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Leave this email empty to send the label to the "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " email set in the request\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "0",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "text" },
                                  on: {
                                    click: function ($event) {
                                      _vm.visible = false
                                    },
                                  },
                                },
                                [_vm._v("\n              cancel\n            ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    disabled: !_vm.validEmail,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.generateLabel()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Confirm\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "reference",
                                type: "warning",
                                size: "small",
                                disabled: !_vm.canGenerateLabel,
                              },
                              slot: "reference",
                            },
                            [_vm._v("\n            Generate label\n          ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.labels },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "Tracking Number", prop: "tracking" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.tracking_link
                                ? _c("span", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: scope.row.tracking_link,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.tracking) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(scope.row.tracking)),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1542170580
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Created at", prop: "created_at" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("time-zone-formatter", {
                                attrs: { "current-time": scope.row.created_at },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2970514713
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Expires at", prop: "expires_at" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("time-zone-formatter", {
                                attrs: { "current-time": scope.row.expires_at },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1902097497
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("h4", { staticClass: "expanded-title" }, [_vm._v("\n    Logs\n  ")]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.requestHistory },
        },
        [
          _c("el-table-column", {
            attrs: { label: "Updated", prop: "update_at", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      { attrs: { type: "info", size: "small" } },
                      [
                        _c("time-zone-formatter", {
                          attrs: { "current-time": scope.row.updated_at },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "State", prop: "new_state", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.$index ? "info" : "",
                          effect: "dark",
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("capitalize")(scope.row.new_state)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Comment", prop: "comment" },
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { label: "Agent", prop: "agent" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }